import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

const LABELS = [
  { value: 1, labelKey: 'studio.difficulty.veryEasy',    fallback: 'Very Easy' },
  { value: 2, labelKey: 'studio.difficulty.easy',        fallback: 'Easy' },
  { value: 3, labelKey: 'studio.difficulty.intermediate',fallback: 'Intermediate' },
  { value: 4, labelKey: 'studio.difficulty.advanced',    fallback: 'Advanced' },
  { value: 5, labelKey: 'studio.difficulty.expert',      fallback: 'Expert' },
];

/**
 * DifficultyPicker — 5-button row writing numeric 1..5.
 * Props:
 *   - value: number | null
 *   - onChange(numeric): writer
 *   - disabled?: boolean
 */
export function DifficultyPicker({ value, onChange, disabled }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex gap-1.5"
      data-testid="studio-difficulty-picker"
      role="radiogroup"
      aria-label="Difficulty"
    >
      {LABELS.map((it) => {
        const selected = value === it.value;
        return (
          <button
            type="button"
            key={it.value}
            disabled={disabled}
            onClick={() => onChange(it.value)}
            data-testid={`studio-difficulty-${it.value}`}
            aria-checked={selected}
            role="radio"
            className={cn(
              'flex-1 rounded-md border-2 px-2 py-1.5 text-xs font-medium transition-all',
              selected
                ? 'border-primary bg-primary text-primary-foreground shadow-sm'
                : 'border-border bg-background hover:border-primary/40',
              disabled ? 'opacity-50 cursor-not-allowed' : '',
            )}
          >
            <div className="font-mono text-base leading-none">{it.value}</div>
            <div className="text-xs mt-0.5 truncate">
              {t(it.labelKey, { defaultValue: it.fallback })}
            </div>
          </button>
        );
      })}
    </div>
  );
}

export function difficultyLabel(t, value) {
  const entry = LABELS.find((l) => l.value === value);
  if (!entry) return '—';
  return t(entry.labelKey, { defaultValue: entry.fallback });
}

export default DifficultyPicker;
